/**
 * The "WHILE YOU WERE AWAY…" Win94 dialog. One window, max ~4 lines,
 * evidence-first tone — never guilt.
 */
import { LEX } from '../strings/lexicon';
import type { AwayReport } from '../save/schema';

export function awayLines(report: AwayReport): string[] {
  const lines: string[] = [LEX.awayHours(report.elapsedH)];
  if (report.splits > 0) lines.push(LEX.awayBorn(report.splits));
  if (report.wentDormant > 0) lines.push(LEX.awayDormant(report.wentDormant));
  if (report.splits === 0 && report.wentDormant === 0) lines.push(LEX.awayQuiet());
  lines.push(LEX.awayPop(report.popAfter));
  return lines;
}

export function showPostcard(parent: HTMLElement, title: string, lines: string[]): void {
  const wrap = document.createElement('div');
  wrap.style.cssText = [
    'position:fixed',
    'inset:0',
    'display:grid',
    'place-items:center',
    'z-index:40',
    'pointer-events:auto',
    'background:rgba(0,0,0,0.25)',
  ].join(';');

  const win = document.createElement('div');
  win.className = 'w94-raised';
  win.style.cssText = 'min-width:240px;max-width:82vw;padding:2px;';

  const bar = document.createElement('div');
  bar.textContent = title;
  bar.style.cssText = [
    'background:linear-gradient(90deg,var(--w94-title-a),var(--w94-title-b))',
    'color:#fff',
    'font:bold 12px/1 monospace',
    'padding:5px 8px',
    'letter-spacing:1px',
  ].join(';');

  const body = document.createElement('div');
  body.style.cssText = 'padding:14px 12px;font:12px/1.8 monospace;color:var(--w94-text);white-space:pre-wrap;';
  body.textContent = lines.join('\n');

  const buttonRow = document.createElement('div');
  buttonRow.style.cssText = 'display:flex;justify-content:center;padding:0 0 12px';
  const ok = document.createElement('button');
  ok.className = 'w94-btn';
  ok.textContent = LEX.okButton();
  ok.style.cssText = 'min-width:88px;height:34px;pointer-events:auto;';
  ok.addEventListener('click', () => wrap.remove());
  buttonRow.appendChild(ok);

  win.append(bar, body, buttonRow);
  wrap.appendChild(win);
  parent.appendChild(wrap);
}
